import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const AbandonedCheckouts = () =>
    import('@/pmd/pages/payments/settings/AbandonedCheckouts.vue')

const AbandonedCheckoutDetails = () =>
    import('@/pmd/pages/payments/settings/AbandonedCheckoutDetails.vue')

export const AbandonedCheckoutsRoute: RouteConfig[] = [
    {
        path: 'payments/v2/abandoned-checkouts',
        name: 'abandoned_checkouts',
        component: AbandonedCheckouts,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] }
    },
    {
        path: 'payments/v2/abandoned-checkouts/:notificationId',
        name: 'abandoned_checkouts-details',
        component: AbandonedCheckoutDetails,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] }
    },
]